// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3UfVU","question":"Question_question__2m63V","description":"Question_description__2NZe9"};